<div class="dropdown-item" [class.dropdown-item--selected]="selected" [class.dropdown-item--disabled]="disabled">
  <div>
    @if (icon !== '') {
      <span class="dropdown-item__icon mr-2"><i [className]="icon"></i></span>
    }
    <span [innerHTML]="label"></span>
  </div>
  @if (selected) {
    <span class="dropdown-item__check-icon"><i class="fa-fw fa-solid fa-check"></i></span>
  }
</div>
